<template>
	<div class="pay">
		
		<div v-if="!payStatus">请选择支付方式</div>

		<div class="penal penal2" v-if="payStatus">
			<h4>已支付</h4>
			<div>即将去往小程序，请耐心等待。。。</div>
			<i class="el-icon-loading"></i>
			<h4 class="go" @click="payRes">去往小程序，参与报名~</h4>
		</div>

		<div class="penal" v-else>
			<div class="pay-type">
				<div :class="payType == 2 ? 'item on' : 'item'" @click="payType = 2">
					<div class="left">
						<img src="../../assets/images/icon/weixin.png" alt="">
						<span>微信支付</span>
					</div>
					<div class="icon"></div>
				</div>
				<!-- <div :class="payType == 1 ? 'item on' : 'item'" @click="payType = 1">
					<div class="left">
						<img src="../../assets/images/icon/alipay.png" alt="">
						<span>支付宝</span>
					</div>
					<div class="icon"></div>
				</div> -->
			</div>
			<div class="pab">
				<div class="btn" @click="doPay">立即支付</div>
			</div>
		</div>
		<div class="mask" v-if="showWxRes">
			<div class="panel panel2">
				<div class="df">
					<div class="btn left" @click="rePay">未支付</div>
					<div class="btn right" @click="reWechat">已支付,添加老师</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';

	export default {
		data () {
			return {
				payType: 2,
				payStatus:false,
				payParams:{},
				wxPoll: null,
				showWxRes: false,
			}
		},
		created(){
			this.payParams = this.$route.query
			this.$store.commit("SET_PATHID", this.payParams.pathId)
			this.$store.commit("SET_PHONE", this.payParams.phone)
			this.$store.commit("SET_PRODUCT", this.payParams.productId)
		},
		mounted(){
			this.getProduct()
		},
		methods:{
			getProduct(){
				axios({
					method:'GET',
					url: `${this.$single}/conf_site/getInfo`,
					params:{
						id: this.payParams.productId
					}
				}).then(res => {
					let data=res.data.data.site_page
					this.payParams.total = data.price
					this.payParams.productName = res.data.data.name
				})
			},
			doPay(){
				this.commonPoint(this.payParams.pathId,this.payParams.productId,'ecPaymentMethod',1)
				this.wechatPay()
				// this.payType == 1 ? this.alipay() : this.wechatPay()
			},
			//支付宝支付
			alipay(){
				axios({
					method:"GET",
					url:`${this.$baseURL}/aliPayment`,
					params: {
						pathId: this.payParams.pathId,
						productId: this.payParams.productId,
						productName: this.payParams.productName,
						total: this.payParams.total,
						userPhone: this.payParams.phone,
						orderId:this.payParams.orderId,
					}
				}).then(res => {
					window.location.href = res.data
				})
			},
			//微信支付
			wechatPay(){
				const params = {
					pathId: this.payParams.pathId,
					productId: this.payParams.productId,
					price: (this.payParams.total)*100,
					productName: this.payParams.productName,
					orderId:this.payParams.orderId,
					userPhone: this.payParams.phone
				}
				axios({
					method:"POST",
					url:`${this.$single}/api/advert/wechatpay/h5PrePay`,
					data: params
				}).then(res => {
					console.log(res);
					this.wxPolling ()
					let that = this
					setTimeout(() => {
						that.showWxRes = true
					},2500)
					setTimeout(() => {
						clearInterval(that.wxPoll)
					},180000)
					window.location.href = res.data.data
				})
			},
			wxPolling(){
				this.wxPoll = setInterval(() => {
					this.wechatOpen(false)
				},1000)
			},
			//支付弹窗-未支付
			rePay(){
				this.showWxRes = false
				this.commonPoint(this.payParams.pathId, this.payParams.productId, "ecNonPayment", 0);
				clearInterval(this.wxPoll)
			},
			//支付弹窗-已支付
			reWechat(){
				this.commonPoint(this.payParams.pathId, this.payParams.productId, "ecNonPayment", 1);
				this.wechatOpen(true)
			},
			//打开获客链接
			wechatOpen(showMsg){
				axios({
					method:"POST",
					url:`${this.$single}/api/advert/launch/getWechatIndexClass`,
					data: {
						userPhone: this.payParams.phone,
						orderId:this.payParams.orderId
					}
				}).then(res => {
					if(res.data.code == 200){
						let data = res.data.data
						this.custSms(data.code,data.wechat_user_id)
						let path = data.wx_index + '?customer_channel=' + data.code + '_H5' + '_' +  this.payParams.productId
						setTimeout(() => {
							window.location.href =  path
						}, 0);
					}
					else{
						if(showMsg){
							this.$message({ message: "支付失败或未查到支付结果" });
						}
					}
				})
			},
			//下发客户短信
			custSms(id,wx){
				axios({
					method:"POST",
					url:`${this.$backend}/customer_acquisition/send_signup_sms`,
					data: {
						"order_code": id,
    					"wx_user_id":wx,
						"prodcut_id":  this.payParams.productId,
						"order_code": this.payParams.orderId
					}
				}).then(res => {
					console.log(res)
				})
			},
		}
	}
</script>

<style scoped>
	.pay{background: #F2F2F2;padding: 20px;height: calc(100vh - 40px);font-size: 16px;}

	.penal{background: #fff;height: calc(100vh - 110px);padding: 0 20px;border-radius: 10px;margin-top: 20px;position: relative;}
	.penal .item{border-bottom: 1px solid #ccc;padding: 20px 0;display: flex;justify-content: space-between;}
	.penal .item .left{display: flex;align-items: center;}
	.penal .item img{width: 30px;height: 30px;margin-right: 10px;}
	.penal .item .icon{width: 40px;height: 40px;border: 1px solid #ccc;border-radius: 50%;transform: scale(.5);}
	.penal .item.on .icon{background: url(../../assets/images/icon/checked.png) no-repeat #FF7200 center;border-color: #FF7200;}
	.penal .pab{bottom: 20px;text-align: center;width: calc(100% - 40px);}
	.penal .btn{color: #fff;font-size: 20px;padding: 10px 25px;display: inline-block;background: linear-gradient(90deg, #ff4242 0%, #ff7e18 100%);width: 240px;border-radius: 30px;}

	.penal2{text-align: center;padding-top: 30px;height: calc(100vh - 150px);}
	.penal2 h4{background: #e1f3d8;width: 200px;border-radius: 20px;padding: 10px;display: inline-block;font-size: 20px;font-weight: normal;margin-bottom: 20px;}
	.penal2 i{font-size: 40px;color: #c1e1b1;margin-top: 20px;}
	.penal2 .go{color: #fff;font-size: 14px;padding: 10px 25px;background: linear-gradient(90deg, #ff4242 0%, #ff7e18 100%);width: 240px;border-radius: 30px;margin-top: 30px;}


	.mask{position: fixed;width: 100vw;height: 100vh;background: rgba(0, 0, 0, 0.5);z-index: 99;top: 0;left: 0;}
	.panel{background: url(../../assets/images/retain.png) no-repeat;width: 100%;height: 305px;background-size: cover;    margin-top: 40%;position: relative;}
	.panel .df{position: absolute;bottom: 0;left: 0;right: 0;justify-content: center;}
	.panel .btn{padding: 10px 20px;border-radius: 10px;margin: 20px 15px 40px;font-size: 20px;font-weight: bold;}
	.panel .left{color: #7D2500;border: 1px solid #7D2500;}
	.panel .right{color: #fff;background: linear-gradient(90deg, #FF0000 0%, #FF7200 100%);}

	.panel{background: url(../../assets/images/retain.png) no-repeat;width: 100%;height: 82vw;background-size: cover;    margin-top: 40%;position: relative;}
	.panel .df{position: absolute;bottom: 0;left: 0;right: 0;justify-content: center;}
	.panel .btn{padding: 10px 20px;border-radius: 10px;margin: 20px 15px 40px;font-size: 20px;font-weight: bold;}
	.panel .left{color: #7D2500;border: 1px solid #7D2500;}
	.panel .right{color: #fff;background: linear-gradient(90deg, #FF0000 0%, #FF7200 100%);}

	.panel2{background-image: url(../../assets/images/pay.png);border-radius: 20px;width: calc(100% - 30px);height: 96vw;margin-left: auto;margin-right: auto;max-height: 666px;max-width: 641px;}
	.panel2 .btn{padding: 10px;margin: 20px 10px;font-weight: normal;}
</style>


// WEBPACK FOOTER //
// src/views/pay/index.vue